import { Select, DatePicker, Input, Form, Row, Col } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { useContext } from "react";
import { leaveTypesArray } from "../../../commons/Arrays/LeavesTypesArray";
import { isAuthenticated } from "../../../commons/Auth/auth";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Error, Success } from "../../../commons/Messages/Messages";
import { SocketContext } from "../../../context/SocketContext";
import GeneralModal from "../../../serviceProvider/components/General.modal";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const onChangetab = key => {};

const AddLeaves = ({ updateParent, employeeObject }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const socket = useContext(SocketContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async values => {
    const leavesData = {
      employee: employeeObject?._id,
      serviceProvider: employeeObject?.employer?._id,
      ...values
    };

    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/leaves/add`, leavesData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });

      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
        handleCancel();
        socket.emit("refresh service provider data", {
          user: isAuthenticated()?.serviceProviderId
        });
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      if (err?.response && err?.response?.data && err?.response?.data?.errors) {
        const validationErrors = err?.response?.data?.errors;
        const errorMessage = Object.values(validationErrors)
          ?.map(err => `${err?.path} is ${err?.kind}.`)
          .join("\n");
        Error(errorMessage);
      } else {
        Error(err.message);
      }
    }
  };

  const items = (
    <>
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="leaveType"
          label={t("Leave Type")}
          rules={[{ required: true, message: t("Please select a leave type") }]}
        >
          <Select
            className="w-100"
            options={leaveTypesArray}
            placeholder={t("Select Leave Type")}
          />
        </Form.Item>

        <Form.Item name="paidStatus" label={t("Paid Status")}>
          <Select
            className="w-100"
            options={[
              { label: t("Paid"), value: true },
              { label: t("Unpaid"), value: false }
            ]}
            placeholder={t("Select Leave Paid Status")}
          />
        </Form.Item>

        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="startDate"
              label={t("Leave Start Date")}
              rules={[{ required: true, message: t("Please select a start date") }]}
            >
              <DatePicker className="w-100" placeholder={t("Select Start Date")} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="endDate"
              label={t("Leave End Date")}
              rules={[{ required: true, message: t("Please select an end date") }]}
            >
              <DatePicker className="w-100" placeholder={t("Select End Date")} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="reason"
          rules={[{ required: true, message: t("Please enter reason for the leave.") }]}
          label={t("Reason")}
        >
          <TextArea rows={4} className="w-100" placeholder={t("Enter Reason")} />
        </Form.Item>

        <Form.Item name="note" label={t("Note")}>
          <TextArea rows={2} className="w-100" placeholder={t("Enter Note")} />
        </Form.Item>
      </Form>
    </>
  );

  return (
    <div className="AddLeaves">
      <MainButtonComp text="Add Leave" addBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Leaves")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default AddLeaves;
